import styled from "styled-components"

export const Teste = styled.a`
  font-size : 20px;
`


export const ContainerAdress = styled.div`
  padding : 10px;
  border-radius : 10px;
  background : #fff;
  margin-bottom : 10px;
  position : relative;
  box-shadow: 1px 1px 5px #999;
`


export const ContainerRow = styled.div`
  display : flex;
  flex-direction : row;
  align-items : center;
  justify-content :space-between;
  width : 100%;
  margin : 0px 0 20px!important;
  padding : 10px 0px 0px !important;
  border-bottom : 1px solid #eee; 
  
`

export const TitleEnderco = styled.h2`
  font-size : 22px;
  margin : 0 !important;
  font-family: 'Arima Madurai', cursive !important;
  font-weight : bold;
  padding : 0 !important;
`


export const CardAdress = styled.div`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 20px;
  box-shadow: 1px 1px 5px #999;
  justify-content : space-between;
  display : flex;
  align-items : center;
`
